import React from 'react'
import PropTypes from 'prop-types'
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'
import DeleteFileIcon from '../graphics/deleteFileIcon';

const DoxExplorerConfirmDelete = ({ fileName, errorStatus }) => {
    const translateString = useTranslationContext();
    return (
        <div className='is-flex is-flex-direction-column is-align-items-center is-justify-content-center doxe-confirm'>
            <DeleteFileIcon color='#89D49F' />
            <div className='p1'>{translateString('Dox.DocumentExplorer.DeletePrompt', { FileName: fileName })}</div>
            {errorStatus === 'fail' &&
                <div className='doxe-red'>{translateString('Dox.DocumentExplorer.Errors.Transient')}</div>
            }
        </div>
    )
}

DoxExplorerConfirmDelete.propTypes = {
    fileName: PropTypes.string.isRequired,
    errorStatus: PropTypes.string
}   

export default DoxExplorerConfirmDelete;